import { createSelector } from 'reselect';

import { createKeySelector } from 'Lib/reduxUtils';

import {
  getIsTinderUVerified,
  TINDER_U_STATUS_VERIFIED,
  TINDER_U_STATUS_VERIFIED_OPT_OUT,
} from './utils';

export const selectTinderU = createKeySelector('tinderU');

const TINDER_U_ELIGIBLE_STATUS = new Set([
  TINDER_U_STATUS_VERIFIED,
  TINDER_U_STATUS_VERIFIED_OPT_OUT,
]);

export const getIsTinderUEligible = createSelector(selectTinderU, (tinderU) =>
  TINDER_U_ELIGIBLE_STATUS.has(tinderU.status || '')
);

export const getIsOptInTinderU = createSelector(selectTinderU, (tinderU) =>
  getIsTinderUVerified(tinderU)
);

export const getTinderUSchool = createSelector(selectTinderU, (tinderU) => tinderU.school);

export const getTinderUEmail = createSelector(selectTinderU, (tinderU) => tinderU.email);
